import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'antd';
import { useUser } from '../UserContext';
import { useInstance } from '../useInstance';

const HeaderMenu = () => {
    const location = useLocation();
    const pathname = location.pathname;
    // define the header options based on user group
    const { userGroups } = useUser();
    // the Dashboard page (Superset) only where Superset is set up
    const { reports } = useInstance();
    const dashboard = reports && <Menu.Item key="/dashboard"><Link to="/dashboard">Dashboard</Link></Menu.Item>;

    return (
        <Menu theme="dark" mode="horizontal" selectedKeys={[pathname]} style={{ width: '100%' }}>
            {userGroups.includes('visitors') ?
                (
                    // visitor
                    <>
                        {dashboard}
                        <Menu.Item key="/orders"><Link to="/orders">Orders</Link></Menu.Item>
                        <Menu.Item key="/log"><Link to="/log">Logs</Link></Menu.Item>
                        <Menu.Item key="/files"><Link to="/files">Files</Link></Menu.Item>
                    </>
                ) : (
                    // admin
                    <>
                        {dashboard}
                        <Menu.Item key="/orders"><Link to="/orders">Orders</Link></Menu.Item>
                        <Menu.Item key="/notifications"><Link to="/notifications">Notifications</Link></Menu.Item>
                        <Menu.Item key="/log"><Link to="/log">Logs</Link></Menu.Item>
                        <Menu.Item key="/files"><Link to="/files">Files</Link></Menu.Item>
                    </>
                )}

        </Menu>
    );
};

export default HeaderMenu;
